module.exports = __webpack_public_path__ + "img/ball2.9efaa4d9.png";